import React from "react";
import "./HowItWorks.css";
// import { Button } from "react-bootstrap";

export default function HowItWorks() {
  return (
    <div className="HowItWorks" id="howit">
      <div className="container PricingPlans1 py-5">
        <div className="row">
          <div className="headerIneer">
            <div className="main">
              <p className="paragraph1 py-3 pb-0 fs-5 fw-bold text-center">
                How it works
              </p>
              <h1 className="fw-bold pt-2 text-center py-4">
                Feel the simplicity
              </h1>
            </div>
          </div>
          <div className="row py-4">
            <div className="col-lg-4 col-md-6 my-3">
            <div className="d-flex flex-row align-items-center my-3">
  <div className="border redGradient text-white fs-1 mx-2 flex-shrink-0">01</div>
  <div className="d-flex flex-column px-3 justify-content-center">
    <h5 className="py-2">Download the app</h5>
    <div className="font-mono">Go to Google play and download the app</div>
  </div>
</div>


            </div>
            <div className="col-lg-4 col-md-6 my-3">
              <div className="d-flex flex-row align-items-center my-3">
                <div className="border blueGradient text-white fs-1 mx-2 flex-shrink-0">02</div>
                <div className="d-flex flex-column px-3 justify-content-center">
                  <h5 className="py-2">Purchase your plan</h5>
                  <div className="font-mono">Pick the plan that suits you</div>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 my-3">
              <div className="d-flex flex-row align-items-center my-3">
                <div className="border greenGradient text-white fs-1 mx-2 flex-shrink-0">03</div>
                <div className="d-flex flex-column px-3 justify-content-center">
                  <h5 className="py-2">Connect</h5>
                  <div className="font-mono">Turn on the VPN and enjoy</div>
                </div>
              </div>
            </div>
          </div>

          <div className="my-5 py-5 privateCard pb-0 d-flex flex-column flex-md-row justify-content-between align-items-center rounded-3xl pt-10 pb-14 px-14">
            <div className="flex-1 min-w-0 text-left sm:mb-0 mb-5">
              <h2 className="text-[40px] leading-[50px] text-[#272e36] font-bold mb-5">
                Get 123MyVPN
              </h2>
              <h5 className="text-xl">
                Download to get private &amp; secure Internet
              </h5>
            </div>
            <div>
              {/* <Button className="btn btn-default startedBtn rounded-4 pt-3 pb-3 px-5">Try now for free</Button> */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
